import loadable from '@loadable/component';

export const SubscriptionPage = loadable(/* #__LOADABLE__ */ () => import('./SubscriptionPage'));
